<template lang="pug">
	.v-catalog-compare.catalog.catalog--compare(:class="{'catalog--initialized': initialized, 'catalog-compare--head-fixed': headFixed}")
		v-loader(:loading="loading")
		.container
			template(v-if="(catalog && !('items' in catalog))")
				.page-title.page-title--flex
					h1.page-title__value {{catalog.title}}
				.catalog__placeholder
					p.catalog__placeholder-title {{catalog.emptyPage.title}}
					p.catalog__placeholder-text
						| {{catalog.emptyPage.text}}
						svg.svg-icon.catalog__placeholder-icon
							use(xlink:href="#svg-icon-compare")
			template(v-if="catalog && catalog.items && catalog.items.length")
				.page-title.page-title--flex
					h1.page-title__value(v-if="catalog.title") {{catalog.title}}
					//span.page-title__quantity(v-if="catalog && catalog.items && catalog.items.length")
						| {{catalog.items.length}} {{pluralize(catalog.items.length, 'товар', ['', 'а', 'ов'])}}

				.catalog__compare-categories
					button.btn.btn--transparent(
						v-for="(item, index) in compCategories"
						:key="item.id"
						:class="{ 'btn--active': activeSectionId === item.id }"
						@click="switchSection(item.id)"
					)
						.catalog__compare-categories_name() {{item.name}} ({{item.count}})

				.catalog__compare-filters
					v-filter(
						ref="filter"
						:filters="catalog.filters"
						@filter-changed="recalcParams")
					button.catalog__compare-delete(@click="reset")
						v-svg-icon.catalog__compare-delete_icon(icon="trash")
						span.catalog__compare-delete_title Удалить все товары

				.catalog__compare-layout(v-if="catalog.items && catalog.items.length")
					.catalog-compare__body.flc
						.catalog-compare.flc(@scroll="tableScroll")
							.catalog-compare__head(:style="{'width': computedWidth}")
								.catalog-compare__scrollbar(v-if="isSm" ref="scrollbar" @click="onScrollbarClick")
									.catalog-compare__scrollbar-nav(:style="{width: `${scrollbarWidth || 0}%`, left: +this.currentOffset+'px'}" ref="scrollbarNav" @mousedown="onScrollbarMouseDown")
								.catalog-compare__head-layout
									.catalog-compare__head-aside
										.catalog-compare__head-mod

									.catalog-compare__head-main(ref="overviewContainer" @touchstart="dragStart" @touchend="dragEnd" @touchmove="dragMove")
										.catalog-compare__scrollbar(v-if="!isSm" ref="scrollbar" @click="onScrollbarClick")
											.catalog-compare__scrollbar-nav(:style="{width: `${scrollbarWidth || 0}%`, left: +this.currentOffset+'px'}" ref="scrollbarNav" @mousedown="onScrollbarMouseDown")
										.catalog-compare__head-items(v-if='catalog.items')
											.catalog-compare__head-items-grid(ref="scrollContainer" :style="{'transform': `translate3d(${+currentSlideOffset},0,0) translateX(${+dragOffset}px)`, 'transition': computedTransition}" @scroll.passive="syncScroll")
												.catalog-compare__head-item(v-for="item in actualItems" ref="elementContainer")
													img.v-image.image(:src="item.image.medium" :alt="item.name" loading="lazy")
													a.catalog-compare__head-item_title(:href="item.link") {{item.name}}
													v-svg-icon.catalog-compare__head-item_delete(icon="close" @click="deleteItem(item.id)")

							.catalog-compare__body-group(v-for='(paramGroup,index) in paramGroups' :class="{'open': paramGroup.open}")
								.catalog-compare__body-group-header
									.catalog-compare__body-group-header-title.catalog-compare__table-aside() {{paramGroup.title}}
									.catalog-compare__table-row(:style="{'height': index > 0 ? '78px' : '36px'}")
										.catalog-compare__table-main
											.catalog-compare__table-main-grid(ref="scrollContainer" :style="{'transform': 'translate3d(' + currentSlideOffset + ',0,0) translateX(' + dragOffset + 'px)', 'transition': computedTransition}" @scroll.passive="syncScroll")
												.catalog-compare__table-main-cell(v-for='value in paramGroup.params[Object.keys(paramGroup.params)[0]].values.length') {{' '}}

								.catalog-compare__table
									.catalog-compare__table-row(v-for='param in paramGroup.params')
										.catalog-compare__table-aside {{param.title}}
										.catalog-compare__table-main
											.catalog-compare__table-main-grid(ref="scrollContainer" :style="{'transform': 'translate3d(' + currentSlideOffset + ',0,0) translateX(' + dragOffset + 'px)', 'transition': computedTransition}" @scroll.passive="syncScroll")
												.catalog-compare__table-main-cell(v-for='value in param.values') {{value ? value.text : '-'}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';
import breakpoints from '../scripts/breakpoints';
import {mapGetters} from 'vuex';
import VImage from "./helpers/v-image.vue";
import VProductImage from "./v-product-image.vue";
import VField from "./v-field.vue";
import VSvgIcon from "./helpers/v-svg-icon.vue";
import isMobMixin from "./mixins/v-mixin-is-mob.vue";

export default {
	components: {VSvgIcon, VField, VProductImage, VImage},
	mixins: [
		sourceMixin,
		formattingMixin,
		isMobMixin
	],

	data() {
		return {
			catalog: {
				items: null,
				remote: null
			},
			loading: false,
			loadingMinTimeout: null,
			initialized: false,
			activeSectionId: null,
			paramGroups: null,
			currentSlide: 0,
			slidesToShow: undefined,
			headFixed: false,
			excludeSimilar: false,
			dragOn: false,
			dragStartPosition: undefined,
			dragOffsetReal: 0,
			dragOffset: 0,
			computedTransition: 'none',
			computedWidth: 'auto',
			widthOfItem: undefined,
			resizeTimeout: null,
			headNav: null,
			isDragging: false,
			startX: 0,
			scrollLeft: 0,
			scrollBlock: null,
			scrollbarPosition: 0,
			scrollbarWidth: 0,
			currentOffset: 0,
			filterStatus: 'all'
		};
	},

	computed: {
		...mapGetters({
			items: 'compare/items'
		}),

		sections() {
			if (!this.catalog || !this.catalog.items || !this.catalog.items.length) {
				return null;
			}

			return this.getUniqueCategoriesWithCount(this.catalog.items);
		},

		actualItems() {
			if (this.sections.length && (!this.activeSectionId || !this.sections.find(elem => elem.id === this.activeSectionId))) {
				this.activeSectionId = this.sections[0].id;
			}
			let result = [];
			this.catalog.items.forEach(item => {
				if (item.categories.filter(({id}) => id === this.activeSectionId).length === 0) {
					return;
				}
				result.push(item);
			});

			return result;
		},

		currentSlideOffset() {
			return -this.currentSlide * 100 / this.slidesToShow + '%';
		},

		itemsCount() {
			return this.catalog.items.reduce((memo, item) => {
				if (item.sectionId === this.activeSectionId) {
					return memo + 1;
				} else {
					return memo;
				}
			}, 0);
		},

		compCategories() {
			this.activeSectionId = this.getUniqueCategoriesWithCount(this.catalog.items)[0].id
			return this.getUniqueCategoriesWithCount(this.catalog.items);
		},
	},

	watch: {
		items() {
			this.requestDataLoad();
		}
	},

	mounted() {
		this.scrollbarCompWidth()
		this.recalcParams()
		console.log('mounted', this.catalog);
		setTimeout(() => {
			this.$refs.scrollBlock.addEventListener('scroll', this.handleScroll);
		}, 500)
	},

	methods: {
		getUniqueCategoriesWithCount(items) {
			const categoryMap = new Map();

			items.forEach(({ categories }) => {
				categories.forEach(({ id, name }) => {
					if (!categoryMap.has(id)) {
						categoryMap.set(id, { id, name, active: false, count: 0 });
					}
					categoryMap.get(id).count++;
				});
			});

			return Array.from(categoryMap.values());
		},

		isPrevArrowDisabled() {
			return this.currentSlide === 0;
		},

		isNextArrowDisabled() {
			return this.currentSlide + this.slidesToShow >= this.itemsCount;
		},

		scrollbarCompWidth() {
			setTimeout(() => {
				const overviewContainerElem = Array.isArray(this.$refs.overviewContainer) ? this.$refs.overviewContainer[0] : this.$refs.overviewContainer;
				const elementContainerElem = Array.isArray(this.$refs.elementContainer) ? this.$refs.elementContainer[0] : this.$refs.elementContainer;

				const overviewContainer = overviewContainerElem.clientWidth || 500;
				const elementContainer = elementContainerElem.clientWidth || 600;
				const sumWidth = elementContainer * this.actualItems.length;

				if (sumWidth > overviewContainer) {
					const width = (overviewContainer / sumWidth) * 100
					this.scrollbarWidth = width;
					console.log(width, overviewContainer, sumWidth);
				} else {
					this.scrollbarWidth = 100;
				}
			}, 500);
		},

		dragStart(e) {
			if (window.innerWidth <= breakpoints['2xs-max']) {
				return;
			}
			this.dragOn = true;
			this.dragStartPosition = e.touches[0].pageX;
			this.computedTransition = 'none';
			this.widthOfItem = this.$el.querySelector('.catalog-compare__head-item').offsetWidth;
		},

		syncScroll(event) {
			const isMobile = this.isSm;

			const scrollbar = this.$refs.scrollbar ? this.$refs.scrollbar.clientWidth : visibleWidth;
			const scrollbarNav = this.$refs.scrollbarNav ? this.$refs.scrollbarNav.clientWidth : 50;
			if (!this.$refs.scrollContainer) return;

			const scrollContainer = this.$refs.scrollContainer[0];
			const visibleWidth = scrollContainer?.clientWidth;
			const scrollContainerWidth = scrollContainer?.scrollWidth;
			const widthOfElement = this.$refs.elementContainer[0]?.clientWidth;
			const totalContentWidth = this.catalog.items.length * widthOfElement;

			const maxScrollOffset = scrollContainerWidth - visibleWidth;
			const maxScrollbarOffset = scrollbar - scrollbarNav;

			const scrollLeft = Math.min(Math.max(event?.target.scrollLeft, 0), maxScrollOffset);

			this.currentOffset = (scrollLeft / maxScrollOffset) * maxScrollbarOffset;

			const grids = this.$el.querySelectorAll('.catalog-compare__table-main-grid, .catalog-compare__head-items-grid');
			grids.forEach((grid) => {
				if (grid !== event?.target) {
					grid.scrollLeft = scrollLeft;
				}
			});

			this.scrollLeft = scrollLeft;
		},

		onScrollbarMouseDown(e) {
			this.isDraggingScrollbar = true;
			this.startX = e.clientX;
			this.startOffset = this.currentOffset || 0;

			document.addEventListener('mousemove', this.onScrollbarMouseMove);
			document.addEventListener('mouseup', this.onScrollbarMouseUp);
		},

		onScrollbarMouseMove(e) {
			if (!this.isDraggingScrollbar) return;

			const deltaX = e.clientX - this.startX;

			const scrollbar = this.$refs.scrollbar.clientWidth;
			const scrollbarNav = this.$refs.scrollbarNav.clientWidth;
			const scrollContainer = Array.isArray(this.$refs.scrollContainer) ? this.$refs.scrollContainer[0] : this.$refs.scrollContainer;

			const scrollContainerWidth = scrollContainer.scrollWidth;
			const visibleWidth = scrollContainer.clientWidth;

			const maxScrollOffset = scrollContainerWidth - visibleWidth;
			const maxScrollbarOffset = scrollbar - scrollbarNav;

			let newOffset = Math.min(Math.max(this.startOffset + deltaX, 0), maxScrollbarOffset);
			this.currentOffset = newOffset;

			const scrollLeft = (newOffset / maxScrollbarOffset) * maxScrollOffset;
			scrollContainer.scrollLeft = scrollLeft;
		},

		onScrollbarMouseUp() {
			this.isDraggingScrollbar = false;
			document.removeEventListener('mousemove', this.onScrollbarMouseMove);
			document.removeEventListener('mouseup', this.onScrollbarMouseUp);
		},

		onScrollbarClick(e) {
			if (e.target !== this.$refs.scrollbar) return;

			const scrollbar = this.$refs.scrollbar.clientWidth;
			const scrollbarNav = this.$refs.scrollbarNav.clientWidth;

			const clickX = e.offsetX - scrollbarNav / 2;
			const maxScrollbarOffset = scrollbar - scrollbarNav;
			const newOffset = Math.min(Math.max(clickX, 0), maxScrollbarOffset);
			this.currentOffset = newOffset;

			const scrollContainer = this.$refs.scrollContainer[0];
			const scrollContainerWidth = scrollContainer.scrollWidth;
			const visibleWidth = scrollContainer.clientWidth;
			const maxScrollOffset = scrollContainerWidth - visibleWidth;

			const scrollLeft = (newOffset / maxScrollbarOffset) * maxScrollOffset;
			scrollContainer.scrollLeft = scrollLeft;
		},

		dragEnd() {
			if (window.innerWidth <= breakpoints['2xs-max']) {
				return;
			}
			this.dragOn = false;
			this.computedTransition = 'transform .3s';
			this.currentSlide = Math.round((this.widthOfItem * this.currentSlide - this.dragOffset) / this.widthOfItem);
			if (this.currentSlide + this.slidesToShow >= this.itemsCount) {
				this.currentSlide = this.itemsCount - this.slidesToShow;
			}
			if (this.currentSlide < 0) {
				this.currentSlide = 0;
			}
			this.dragOffset = 0;
		},

		dragMove(e) {
			if (!this.dragOn) {
				return;
			}
			this.dragOffsetReal = e.touches[0].pageX - this.dragStartPosition;
			if (this.widthOfItem * this.currentSlide - this.dragOffsetReal < 0) {
				this.dragOffset = this.widthOfItem * this.currentSlide;
			} else {
				this.dragOffset = this.dragOffsetReal;
			}
		},

		recalcParams(e) {
			this.filterStatus = e?.SORT?.value || (this.filterStatus ?? 'all')
			let vm = this;
			if (!this.catalog || !this.catalog.items || !this.catalog.items.length) {
				vm.paramGroups = null;
				return;
			}
			if (this.sections.length && (!this.activeSectionId || !this.sections.find(elem => elem.id === this.activeSectionId))) {
				this.activeSectionId = this.sections[0].id;
			}
			let result = {};
			this.catalog.items.forEach(item => {
				if (item.categories.filter(({id}) => id === this.activeSectionId).length === 0) {
					return;
				}
				item.params.forEach(paramGroup => {
					if (!result[paramGroup.id]) {
						result[paramGroup.id] = {
							id: paramGroup.id,
							title: paramGroup.title,
							open: true,
							params: {}
						};
					}
					paramGroup.params.forEach(param => {
						if (!result[paramGroup.id].params[param.id]) {
							result[paramGroup.id].params[param.id] = {
								id: param.id,
								title: param.title,
								tip: param.tip || null,
								values: []
							};
						}
					});
				});
			});
			//fill params matrix (fill gaps with null)
			Object.values(result).forEach(resultParamGroup => {
				Object.values(resultParamGroup.params).forEach(resultParam => {
					this.catalog.items.forEach(item => {
						if (item.categories.filter(({id}) => id === this.activeSectionId).length === 0) {
							return;
						}

						let itemParamsGroup = item.params.find(elem => elem.id === resultParamGroup.id);
						let itemParamsValue = itemParamsGroup ? itemParamsGroup.params.find(elem => elem.id === resultParam.id) : null;
						resultParam.values.push(itemParamsValue);
					});
				});
			});
			// exclude similar
			if (vm.filterStatus === "all") {
				result = Object.values(result).map(resultParamGroup => {
					resultParamGroup.params = Object.values(resultParamGroup.params).map(resultParam => {
						let values = [];
						this.catalog.items.forEach(item => {
							if (item.categories.filter(({id}) => id === this.activeSectionId).length === 0) {
								return;
							}
							if (!resultParamGroup || !resultParam) {
								return;
							}

							let itemParamsGroup = item.params.find(elem => elem.id === resultParamGroup.id);
							let itemParamsValue = itemParamsGroup ? itemParamsGroup.params.find(elem => elem.id === resultParam.id) : null;
							values.push(itemParamsValue);
						});

						resultParam.values = values;
						return resultParam;
					});
					return resultParamGroup;
				});
			}
			else if (vm.filterStatus === 'exclude') {
				result = Object.values(result).filter(resultParamGroup => {
					resultParamGroup.params = Object.values(resultParamGroup.params).filter(resultParam => {
						let testValue;
						let diffFound = false;

						this.catalog.items.forEach(item => {
							if (item.categories.filter(({id}) => id === this.activeSectionId).length === 0) {
								return;
							}
							if (!resultParamGroup || !resultParam) {
								return;
							}

							let itemParamsGroup = item.params.find(elem => elem.id === resultParamGroup.id);
							let itemParamsValue = itemParamsGroup ? itemParamsGroup.params.find(elem => elem.id === resultParam.id) : null;

							if (typeof testValue == 'undefined') {
								testValue = itemParamsValue;
							} else if (itemParamsValue && testValue.text === itemParamsValue.text) {
								diffFound = true;
							}
						});

						return diffFound;
					});

					return resultParamGroup && resultParamGroup.params.length;
				});
			} else if (vm.filterStatus === 'include') {
				result = Object.values(result).filter(resultParamGroup => {
					resultParamGroup.params = Object.values(resultParamGroup.params).filter(resultParam => {
						let testValue;
						let sameFound = true;

						this.catalog.items.forEach(item => {
							if (item.categories.filter(({id}) => id === this.activeSectionId).length === 0) {
								return;
							}
							let itemParamsGroup = item.params.find(elem => elem.id === resultParamGroup.id);
							let itemParamsValue = itemParamsGroup ? itemParamsGroup.params.find(elem => elem.id === resultParam.id) : null;

							if (typeof testValue === 'undefined') {
								testValue = itemParamsValue;
							} else {
								const textA = testValue?.text ?? null;
								const textB = itemParamsValue?.text ?? null;
								if (textA !== textB) {
									sameFound = false;
								}
							}
						});

						return !sameFound;
					});
					return resultParamGroup && resultParamGroup.params.length;
				});
			}
			vm.paramGroups = result;
		},

		tableScroll() {
			if (this.$refs.scrollContainer.scrollLeft !== this.$refs.headNav.scrollLeft) {
				this.$refs.headNav.scrollLeft = this.$refs.scrollContainer.scrollLeft;
			}
		},

		handleScroll() {
			this.isUserScrolling = (window.scrollY > 0);
			if (this.$refs.headPlaceholder && this.$refs.compareBody) {
				this.headFixed = this.$refs.headPlaceholder.getBoundingClientRect().top <= 0 && this.$refs.compareBody.getBoundingClientRect().bottom >= 0;
			}
		},

		handleResize() {},

		deleteItem(id) {
			const result = this.catalog.items.filter(item => +item.id !== +id);
			this.catalog.items = result;
			// this.$store.commit('compare/removeItem', id);
			this.$store.dispatch('compare/remove', [id]);
			this.recalcParams();
			this.scrollbarCompWidth()
			this.syncScroll()
		},

		switchSection(id) {
			this.activeSectionId = id;
			this.recalcParams();
			this.waitForRefs();
			this.scrollbarCompWidth();
			this.syncScroll();


		},

		waitForRefs(retries = 10) {
			if (retries <= 0) return;

			this.$nextTick(() => {
				const overview = this.$refs.overviewContainer;
				const element = this.$refs.elementContainer;

				if (
					!overview ||
					(Array.isArray(overview) && !overview[0]) ||
					!element ||
					(Array.isArray(element) && !element[0])
				) {
					setTimeout(() => this.waitForRefs(retries - 1), 100);
				} else {
					this.scrollbarCompWidth();
					this.syncScroll();
				}
			});
		},

		reset() {
			const ids = this.catalog.items.map(item => item.id)
			// this.$store.commit('compare/remove', {id: this.data.id})
			this.$store.dispatch('compare/remove', ids);
			this.catalog.items = [];
		},

		dataSet(data) {
			this.catalog = data;
			this.getUniqueCategoriesWithCount(this.catalog.items);
			this.recalcParams();
			this.$nextTick(() => {
				this.initialized = true;
			});
			this.handleResize();
			this.$nextTick(() => {
				clearInterval(this.resizeTimeout);
				this.resizeTimeout = setTimeout(() => {
					this.handleScroll();
				}, 200);
				setTimeout(() => {
					this.handleResize();
				}, 100);
			});
		},

		requestDataLoad() {
			if (this.catalog && this.catalog.remote) {
				this.dataLoad({
					url: this.catalog.remote,
					delay: true
				});
			}
		}
	}
};
</script>